<template>
	<div id="newsletter-modal" class="modal fade">
		<div class="modal-dialog modal-dialog-centered">
			<div class="modal-content">
				<button
					type="button"
					class="button dismiss-button ion ion-ios-close"
					data-dismiss="modal"
				></button>
				<div class="modal-body u-s-p-x-0">
					<div class="row align-items-center u-s-m-x-0">
						<div class="col-lg-6 col-md-6 col-sm-12 u-s-p-x-0">
							<div class="newsletter-image">
								<a href="#" class="banner-hover effect-dark-opacity">
									<img
										class="img-fluid"
										:src="publicPath + 'assets/images/image_modal.png'"
										alt="image_modal.png"
									/>
								</a>
							</div>
						</div>
						<div class="col-lg-6 col-md-6 col-sm-12">
							<div class="newsletter-wrapper">
								<h1>
									New to <span>{{ AppName }}</span> ? <br />Subscribe Newsletter
								</h1>
								<h5>Get latest product update...</h5>
								<form @submit.prevent="handleSubsFormSubmit">
									<div class="u-s-m-b-35">
										<input
											type="text"
											class="newsletter-textfield"
											placeholder="Enter Your Phone Number"
											required
											v-model="phone_number"
										/>
									</div>
									<div class="u-s-m-b-35">
										<button class="button button-primary d-block w-100">Subscribe</button>
									</div>
								</form>
								<h6>
									Be the first for getting special deals and offers, Send directly to your inbox.
								</h6>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import {publicPath} from "../../../vue.config";
	export default {
		data() {
			return {
				publicPath: publicPath,
				AppName: process.env.VUE_APP_SHOP_NAME,
				phone_number: "",
			};
		},
		methods: {
			openModal() {
				setTimeout(() => {
					$("#newsletter-modal").modal("show");
				}, 5000);
			},
			handleSubsFormSubmit() {
				localStorage.setItem("is_user_subscribed", true);
				$("#newsletter-modal").modal("hide");
			},
		},
		mounted() {
			if (
				!localStorage.getItem("is_user_subscribed") &&
				process.env.VUE_APP_SHOW_SUBSCRIPTION_MODAL == 'true'
			) {
				this.openModal();
			}
		},
	};
</script>

<style scoped>
	.modal-body {
		height: 100%;
	}
	.modal-body img {
		object-fit: cover;
		height: 500px;
	}
	@media (max-width: 991px) {
		.modal-body img {
			height: 300px;
		}
	}
</style>
